
import { useState, useEffect } from 'react';

interface ContactInfo {
  phone: string;
  whatsapp: string;
}

const FloatingContactButtons = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [contactInfo, setContactInfo] = useState<ContactInfo>({
    phone: '+91 7484984048',
    whatsapp: '+91 7484984048'
  });

  // In a real implementation, this would fetch from your contact management system
  useEffect(() => {
    // This would typically fetch from your admin dashboard's contact settings
    // For now, we'll use the default values
    setContactInfo({
      phone: '+91 7484984048',
      whatsapp: '+91 7644047648'
    });
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const callSalon = () => {
    window.open(`tel:${contactInfo.phone}`, '_self');
    setIsOpen(false);
  };

  const whatsappSalon = () => {
    const cleanNumber = contactInfo.whatsapp.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanNumber}`, '_blank');
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Floating Action Buttons */}
      <div className={`flex flex-col space-y-3 mb-3 transition-all duration-300 ${
        isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}>
        {/* WhatsApp Button */}
        <button
          onClick={whatsappSalon}
          className="w-12 h-12 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer transform hover:scale-110"
          title="WhatsApp"
        >
          <i className="ri-whatsapp-fill text-xl"></i>
        </button>

        {/* Call Button */}
        <button
          onClick={callSalon}
          className="w-12 h-12 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer transform hover:scale-110"
          title="Call Now"
        >
          <i className="ri-phone-fill text-xl"></i>
        </button>
      </div>

      {/* Toggle Button */}
      <button
        onClick={toggleMenu}
        className={`w-14 h-14 bg-primary-400 hover:bg-primary-500 text-black rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer transform hover:scale-110 ${
          isOpen ? 'rotate-45' : 'rotate-0'
        }`}
        title="Contact Options"
      >
        <i className={`${isOpen ? 'ri-close-line' : 'ri-customer-service-2-fill'} text-xl`}></i>
      </button>
    </div>
  );
};

export default FloatingContactButtons;